<template>
  <v-container fluid>
    <loader :show="$isLoading()" :message="messageLoader"></loader>
    <confirm-modal
      :dialog="showConfirm"
      :message="confirmMessage"
      @confirm="confirmResponse($event)"></confirm-modal>
    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h3 class="green--text headline mb-0">Usuarios</h3>
      </v-flex>
      <v-flex xs6 md5 text-xs-right>
        <v-tooltip left>
          <v-btn
            dark
            color="green"
            slot="activator"
            @click="goNewUser"
            fab
            small>
              <v-icon>add</v-icon>
            </v-btn>
          <span>Nuevo Usuario</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-text-field
          box
          name="searchbar"
          label="Buscar usuarios"
          append-icon="search"
          color="green"
          v-model="filter"></v-text-field>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-data-table
        :rows-per-page-items="[25,50,100]"
          :headers="headers"
          :items="currentUsers"
          :search="filter"
          class="elevation-1"
          light
          :loading="tableLoading"
          rows-per-page-text="Filas por página"
          >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left green--text"
                @click="goEditUser(props.item.id)">
                <span class="cursor-pointer">{{ props.item.name }}</span>
            </td>
            <td class="text-xs-left grey--text">{{ props.item.email }}</td>
            <td class="text-xs-left grey--text">{{ props.item.phone }}</td>
            <td class="text-xs-left grey--text">{{ props.item.type }}</td>
            <td class="text-xs-left grey--text">
              <v-tooltip left v-if="props.item.id != currentSession.id">
                <v-switch
                  v-model="props.item.active == 1"
                  light
                  color="green"
                  @click="disableUser($event, props.item)"
                  slot="activator">
                  </v-switch>
                  <span>{{ props.item.active == 1 ? 'Habilitado' : 'Inhabilitado' }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left">
              <v-tooltip left v-if="props.item.id != currentSession.id">
                <v-btn
                    @click="deleteUser($event, props.item)"
                    flat
                    icon
                    light
                    slot="activator">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar Usuario</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "Users",
  data: () => ({
    messageLoader: 'Cargando Usuarios...',
    loader: false,
    filter: '',
    actionSelected: '',
    userSelected: [],
    showConfirm: false,
    confirmMessage: '¿Estas seguro que quieres inhabilitar el usuario?',
    // Muestra un pequeño loading encima de la tabla dependiendo de su valor (True, False)
    tableLoading: false,
    headers: [
      { text: 'Nombre', value: 'name', align: 'left' },
      { text: 'Correo', value: 'email', align: 'left' },
      { text: 'Telefono', value: 'phone', align: 'left' },
      { text: 'Tipo de usuario', value: 'userType', align: 'left' },
      { text: 'Estado', value: 'status', align: 'left' },
      { text: '', value: 'delete', align: 'left' }
    ]
  }),
  beforeMount() {
    //do something before mounting vue instance

  },
  mounted() {
    //do something after mounting vue instance
  },
  created() {

    //do something after creating vue instance
    this.loader = true
    this.loadUsers(
      {
        callback: (response) => {
          this.loader = false

        },
        errorCallback: (error) => {
          // Do something after error occurs
          this.loader = false
        }
      }
    )
  },
  computed: {
    ...mapGetters([
      'currentUsers',
      'currentSession'
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ])
  },
  methods: {
    ...mapActions([
      'loadUsers',
      'goNewUser',
      'goEditUser',
      'removeUser',
      'activeUser'

    ]),
    disableUser(event, user) {
      this.actionSelected = 'disableUser'
      this.userSelected = user
      let msg1 = '¿Estas seguro que quieres inhabilitar el usuario?'
      let msg2 = '¿Estas seguro que quieres habilitar el usuario?'
      this.confirmMessage = user.active == 1 ? msg1 : msg2
      this.showConfirm = true
    },

    deleteUser(event, user) {
      this.userSelected = user
      this.actionSelected = 'deleteUser'
      this.confirmMessage = '¿Estas seguro que quieres borrar el usuario?'
      this.showConfirm = true
    },

    confirmResponse(response) {
      if(response){

        //En caso la respuesta del usuario sea positiva
        if(this.actionSelected === 'disableUser'){
          this.activeUser(this.userSelected)
        }else if(this.actionSelected === 'deleteUser'){
          this.removeUser(this.userSelected)
        }

      }else {
        //En caso la respuesta del usuario sea negativa
      }
      this.showConfirm = false
    }
  }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/users/users.vue